export const validPhoneNumber = (value) => {
  if (!value) return true
  return /^9\d{8}$/.test(value) || /^\+569\d{8}$/.test(value) || /^569\d{8}$/.test(value)
}

export const isUrl = (value) => {
  const urlPattern = /^(https?:\/\/)?([\w.-]+)\.[\w.-]+(\/[^\s]*)?$/
  const localUrlPattern = /^(https?:\/\/)?localhost:\d+\/[^\s]*$/
  return urlPattern.test(value) || localUrlPattern.test(value)
}

export const getInvalidFeedback = (v) => {
  if (v.$dirty) {
    if (Object.hasOwn(v, 'required') && !v.required) {
      return 'Este campo es requerido'
    }
    if (Object.hasOwn(v, 'validPhoneNumber') && !v.validPhoneNumber) {
      return 'Debe iniciar con 9 y tener 9 dígitos, por ejemplo: 912345678'
    }
    if (Object.hasOwn(v, 'isUrl') && !v.isUrl) {
      return 'Debe ser una URL válida'
    }
    if (Object.hasOwn(v, 'uniqueExternalId') && !v.uniqueExternalId) {
      return 'Ya existe un paquete con este ID externo'
    }
    if (Object.hasOwn(v, 'duplicatedExternalId') && !v.duplicatedExternalId) {
      return 'El ID externo debe está duplicado'
    }
  }
  return ''
}
